import type { SupervisorActionDefinition } from './types'

export const supervisorActionRegistry: Record<string, SupervisorActionDefinition> = {
  'skills.list': {
    action: 'skills.list',
    kind: 'zulu.api',
    riskLevel: 'low',
    title: 'List skills',
    description: 'Read the skills available to the current account.',
    requiresConfirmation: false
  },
  'skills.get': {
    action: 'skills.get',
    kind: 'zulu.api',
    riskLevel: 'low',
    title: 'Read skill details',
    description: 'Read a specific skill definition and metadata.',
    requiresConfirmation: false
  },
  'skills.publish': {
    action: 'skills.publish',
    kind: 'zulu.api',
    riskLevel: 'medium',
    title: 'Publish skill',
    description: 'Create or update a skill in the current account.',
    requiresConfirmation: true
  },
  'plugins.list': {
    action: 'plugins.list',
    kind: 'zulu.api',
    riskLevel: 'low',
    title: 'List plugins',
    description: 'Read the plugins available to the current account.',
    requiresConfirmation: false
  },
  'plugins.get': {
    action: 'plugins.get',
    kind: 'zulu.api',
    riskLevel: 'low',
    title: 'Read plugin details',
    description: 'Read a specific plugin definition and metadata.',
    requiresConfirmation: false
  },
  'plugins.publish': {
    action: 'plugins.publish',
    kind: 'zulu.api',
    riskLevel: 'medium',
    title: 'Publish plugin',
    description: 'Create or update a plugin in the current account.',
    requiresConfirmation: true
  },
  'skills.assignToRole': {
    action: 'skills.assignToRole',
    kind: 'zulu.api',
    riskLevel: 'medium',
    title: 'Assign skill to role',
    description: 'Attach a skill to a role in the current account.',
    requiresConfirmation: true
  },
  'skills.assignToAgent': {
    action: 'skills.assignToAgent',
    kind: 'runtime.agent',
    riskLevel: 'medium',
    title: 'Assign skill to agent',
    description: 'Attach a skill to a running agent or agent definition.',
    requiresConfirmation: true
  },
  'skills.unassignFromRole': {
    action: 'skills.unassignFromRole',
    kind: 'zulu.api',
    riskLevel: 'medium',
    title: 'Remove skill from role',
    description: 'Detach a skill from a role in the current account.',
    requiresConfirmation: true
  },
  'roles.list': {
    action: 'roles.list',
    kind: 'zulu.api',
    riskLevel: 'low',
    title: 'List roles',
    description: 'Read the roles available to the current account.',
    requiresConfirmation: false
  },
  'agents.list': {
    action: 'agents.list',
    kind: 'zulu.api',
    riskLevel: 'low',
    title: 'List agents',
    description: 'Read the agents available to the current account.',
    requiresConfirmation: false
  },
  'agents.attachSkill': {
    action: 'agents.attachSkill',
    kind: 'runtime.agent',
    riskLevel: 'medium',
    title: 'Attach skill to agent',
    description: 'Attach a skill to an agent runtime or configuration.',
    requiresConfirmation: true
  },
  'secrets.writeRoleSkill': {
    action: 'secrets.writeRoleSkill',
    kind: 'secrets.write',
    riskLevel: 'high',
    title: 'Write role skill secrets',
    description: 'Write secrets required by a role skill binding.',
    requiresConfirmation: true
  }
}

export function getSupervisorActionDefinition(action: string): SupervisorActionDefinition | null {
  return supervisorActionRegistry[action] || null
}
